import { SetStateAction } from 'react';

import { TextField } from '@mui/material';

import { IQuestion } from 'pages/task/types';

export interface ITextAreaProps {
  value: string | string[] | null;
  question: IQuestion;
  setAnswer: (key: string) => void;
}

const TextArea = ({ value, question, setAnswer }: ITextAreaProps) => {
  const handleChange = (event: {
    target: { value: SetStateAction<string | string[] | null> };
  }) => {
    setAnswer(event.target.value as string);
  };

  return (
    <TextField
      data-testid="textarea-option-component"
      multiline
      label={question.label}
      placeholder={question.placeholder || ''}
      value={value || ''}
      onChange={handleChange}
      type="text"
      fullWidth
      sx={{ mb: 3 }}
    />
  );
};

export default TextArea;
